var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('iframe',{staticStyle:{"position":"absolute","border":"0","margin":"0","width":"100%","height":"100%","overflow":"hidden"},attrs:{"src":_vm.src,"webkitallowfullscreen":"","mozallowfullscreen":"","allowfullscreen":""}})}
var staticRenderFns = []

export { render, staticRenderFns }